import { create } from "zustand";
import type { MachineState } from "../components/ai-coach/types";
import type {
  ChatMessage,
  JourneyPhase,
  ProfileContext,
  ProgramWithJourneyData,
  Target,
  WidgetDraftBuffer,
} from "../generated-api";

export interface CoachDebugState {
  machineState: MachineState;
  journeyPhase: JourneyPhase | null;
  profileContext: ProfileContext | null;
  targets: Target[];
  programs: ProgramWithJourneyData[];
  completionCount: number;
  messages: ChatMessage[];
  errorMessage: string | null;
  widgetDrafts: WidgetDraftBuffer;
  lastWidgetResult: {
    kind: string;
    result: unknown;
  } | null;
}

interface CoachDebugStore extends CoachDebugState {
  update: (state: Partial<CoachDebugState>) => void;
  hydrate: (data: Partial<CoachDebugState>) => void;
}

export const useCoachDebugStore = create<CoachDebugStore>((set) => ({
  machineState: "booting",
  journeyPhase: null,
  coachState: null,
  profileContext: null,
  targets: [],
  programs: [],
  completionCount: 0,
  messages: [],
  errorMessage: null,
  widgetDrafts: {},
  lastWidgetResult: null,
  update: (next) => set((s) => ({ ...s, ...next })),
  hydrate: (data) =>
    set((state) => ({
      ...state,
      ...data,
    })),
}));
